import { DialogComponent } from '@theme/dialog';

class SizeChartDrawer extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('size-chart-drawer')) {
  customElements.define('size-chart-drawer', SizeChartDrawer);
}